var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-16"},[_c('TitleLogo',{attrs:{"title":_vm.$t('page.mypage.info.title')}}),_c('v-sheet',[_c('Update',{ref:"myInfo"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }